<template>
  <div class="GradeDetailed">
    <div class="title">当前行为分：<span class="record" v-text="getBehaviorScore"></span>分</div>
    <div class="GradeDetailedList">
      <van-list v-model="listData.loading" :finished="listData.finished" finished-text="没有更多了" @load="onLoad">
        <div class="item" v-for="(item, index) in listData.list" :key="index">
          <div class="left">
            <div class="icon iconfont" :class="item.OperationType ? 'icon-tubiao101' : 'reduce icon-tubiao106'"></div>
            <div class="con">
              <div class="label threeRow" v-text="item.Remark"></div>
              <div class="data">{{ item.CreateTime | formatDay }}</div>
            </div>
          </div>
          <div class="right" :class="item.OperationType ? 'reduce' : 'add'">{{ item.OperationType ? '+' : '-' }}{{ item.OperationScore.toFixed(1) }}</div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import { Toast, Indicator } from 'mint-ui'
import { BehaviorScoreLogIndexData } from '@/api/my'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'GradeDetailed',
  data() {
    return {
      listData: {
        loading: false,
        finished: false,
        rows: 10,
        page: 1,
        total: 0,
        list: [],
        sort: 'CreateTime',
        order: 'desc'
      }
    }
  },
  components: {
    'van-list': List
  },
  methods: {
    onLoad() {
      this.fetchData()
    },
    fetchData() {
      if (this.listData.finished === true) return
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {}
      ;({ page: params.page, rows: params.rows, sort: params.sort, order: params.order } = this.listData)
      BehaviorScoreLogIndexData(params)
        .then((res) => {
          this.listData.total = res.total
          this.listData.list = [...this.listData.list, ...res.rows]
          if (this.listData.list.length >= this.listData.total) {
            this.listData.finished = true
            this.listData.loading = false
          } else {
            this.listData.page++
            this.listData.loading = false
          }
          Indicator.close()
        })
        .catch((res) => {
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
          Indicator.close()
        })
    }
  },
  computed: {
    ...mapGetters(['getBehaviorScore'])
  },
  filters: {
    formatDay(val) {
      return moment(val).format('YYYY年MM月DD日  HH:mm')
    }
  },
  created() {
    document.documentElement.scrollTop = 0
  }
}
</script>

<style lang="scss" scoped>
.GradeDetailed {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f2f2f2;
  .title {
    display: flex;
    align-items: center;
    line-height: 30px;
    height: 50px;
    background-color: #fff;
    padding: 0 10px;
    flex-shrink: 0;
    .record {
      color: #f22c2c;
      margin-right: 4px;
    }
  }
  .GradeDetailedList {
    background-color: #fff;
    margin-top: 15px;
    padding: 0 20px;
    flex: 1;
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100px;
      border-bottom: 1px solid #f5f5f5;
      .left {
        display: flex;
        align-items: center;
        .icon {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 45px;
          height: 45px;
          background-color: #f49053;
          color: #fff;
          font-size: 20px;
          border-radius: 50%;
          margin-right: 10px;
          flex-shrink: 0;
        }
        .icon.reduce {
          background-color: #437fe9;
        }
        .con {
          flex: 1;
          flex-shrink: 0;
          box-sizing: border-box;
          font-size: 14px;
          .label {
            font-size: 15px;
            width: 166px;
            margin-bottom: 10px;
          }
          .data {
            color: #abacac;
          }
        }
      }
      .right {
        flex-shrink: 0;
        margin-right: 10px;
      }
    }
    // .item:last-child {
    //     border-bottom: none;
    // }
  }
}
</style>
